import { FEEDBACK_STATUS } from '../../../constants'

export const filterStatus = {
  [FEEDBACK_STATUS.PENDING]: 'Chưa xử lý',
  [FEEDBACK_STATUS.CREATE_SIGN]: 'Người tạo đã ký',
  [FEEDBACK_STATUS.ORTHER]: 'Đã chuyển văn thư',
  [FEEDBACK_STATUS.DOCUMENT_SIGN]: 'Văn thư đã ký',
}
